<script>
  const projects = [
    {
      name: 'Signal API Gateway',
      description:
        'Unified gateway with schema validation, multi-region routing, and per-tenant rate limits.',
      impact: 'Reduced integration time by 50 percent and stabilized burst traffic.',
      stack: 'Go, Envoy, Redis, Postgres'
    },
    {
      name: 'Ledger Event Stream',
      description:
        'Event-driven ledger powering financial reconciliation and audit exports.',
      impact: 'Guaranteed exactly-once writes with replayable audit trails.',
      stack: '.NET, Kafka, SQL Server'
    },
    {
      name: 'Observability Console',
      description:
        'Single pane for tracing, logs, and SLO dashboards across 40 services.',
      impact: 'Cut mean time to resolution from hours to minutes.',
      stack: 'OpenTelemetry, Grafana, Loki'
    },
    {
      name: 'Batch Orchestration Service',
      description:
        'Workflow engine for nightly analytics and data backfills.',
      impact: 'Improved reliability with backpressure and idempotent retries.',
      stack: 'Python, Airflow, BigQuery'
    }
  ];
</script>

<section class="page">
  <div class="page-header">
    <p class="eyebrow">Projects</p>
    <h1>Backend systems built for scale and clarity.</h1>
    <p class="lead">
      A selection of API and data platform projects focused on reliability,
      performance, and operational simplicity.
    </p>
  </div>

  <div class="cards-grid">
    {#each projects as project}
      <article class="project-card">
        <div>
          <h3>{project.name}</h3>
          <p class="muted">{project.description}</p>
        </div>
        <p class="impact">{project.impact}</p>
        <span class="pill">{project.stack}</span>
      </article>
    {/each}
  </div>
</section>
